import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { PlayerStatusBadge } from './PlayerStatusBadge';

type GameDayStatus = 'ready_to_play' | 'not_ready' | 'no_show' | 'injured' | 'substituted' | 'disqualified' | 'under_age';

interface PlayerGameDayStatusProps {
  playerId: string;
  currentStatus?: GameDayStatus;
  onStatusChange: (playerId: string, status: GameDayStatus) => void;
  disabled?: boolean;
}

export const PlayerGameDayStatus = ({ 
  playerId, 
  currentStatus = 'not_ready', 
  onStatusChange,
  disabled = false
}: PlayerGameDayStatusProps) => {
  const statusOptions: { value: GameDayStatus; label: string }[] = [
    { value: 'not_ready', label: 'Not Ready' },
    { value: 'ready_to_play', label: 'Ready to Play' },
    { value: 'no_show', label: 'No Show' },
    { value: 'injured', label: 'Injured' },
    { value: 'substituted', label: 'Substituted' },
    { value: 'disqualified', label: 'Disqualified' },
    { value: 'under_age', label: 'Under Age Requirement' }
  ];

  return (
    <div className="flex items-center gap-2">
      <PlayerStatusBadge status={currentStatus} size="sm" />
      <Select
        value={currentStatus}
        onValueChange={(value) => onStatusChange(playerId, value as GameDayStatus)}
        disabled={disabled}
      >
        <SelectTrigger className="w-32 h-8">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {statusOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};